import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PurchaseActions, PurchaseFacade } from './+state';


@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [
        PurchaseActions,
        PurchaseFacade,
        // PurchaseEpics
    ]
})
export class PurchaseModule {}
